import { AsyncPipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FuseConfirmationService } from '@library/services/confirmation';
import { PwaService } from 'app/services/pwa.service';

@Component({
  selector: 'app-pwa-install',
  template: `
    @if (pwaService.showInstallButton$ | async) {
      <button mat-icon-button matTooltip="Instalar aplicación" (click)="installApp()" class="text-primary">
        <mat-icon [svgIcon]="'heroicons_outline:arrow-down-tray'"></mat-icon>
      </button>
    }
  `,
  standalone: true,
  imports: [MatButtonModule, MatIconModule, MatTooltipModule, AsyncPipe],
})
export class PwaInstallComponent implements OnInit {
  constructor(
    public pwaService: PwaService,
    private _fuseConfirmationService: FuseConfirmationService
  ) {}

  ngOnInit(): void {}

  installApp(): void {
    // Verificar si es un navegador incompatible
    if (this.pwaService.isIncompatibleBrowser()) {
      // Mostrar modal de confirmación antes de redirigir a Chrome
      const dialogRef = this._fuseConfirmationService.open({
        title: 'Navegador no compatible',
        message:
          'Tu navegador actual no es compatible con la instalación de aplicaciones. Se abrirá Google Chrome donde podrás instalar la aplicación.<br><br><strong>Nota:</strong> Deberás volver a iniciar sesión en Chrome para descargar la aplicación.',
        icon: {
          show: true,
          name: 'heroicons_outline:exclamation-triangle',
          color: 'warn',
        },
        actions: {
          confirm: {
            show: true,
            label: 'Abrir en Chrome',
            color: 'primary',
          },
          cancel: {
            show: true,
            label: 'Cancelar',
          },
        },
        dismissible: true,
      });

      // Si el usuario acepta, abrir en Chrome
      dialogRef.afterClosed().subscribe((result) => {
        if (result === 'confirmed') {
          this.pwaService.openInChrome();
        }
      });
    } else {
      // Navegador compatible, proceder con instalación normal
      this.pwaService.promptInstall();
    }
  }
}
